import reactComponentLoader from 'scripts/react-component-loader'

import DocumentPro from './DocumentPro'

reactComponentLoader(DocumentPro, '[data-loyalty-document-pro]')
